export type InterpolateFn = (
  value: string,
  variables: Record<string, string | number | boolean>,
) => string;

export const interpolate: InterpolateFn = (value, variables) =>
  value.replace(/\{\{(\w+)\}\}/g, (_, match) => {
    return variables[match] ? String(variables[match]) : `{{${match}}}`;
  });
